<template>
  <v-container v-if="invoice" style="display: flex;cursor: pointer">
    <v-row class="pare">
      <div class="col-auto" style="align-self: center" @click="viewInvoice()">
        <img v-if="image && !image.toLowerCase().endsWith('.pdf')" align="left" style="margin-right: auto;height: 48px; width: 48px; " :src="'/api/uploads/' + image" sizes="small">
        <div v-if="image && image.toLowerCase().endsWith('.pdf')" style="height: 48px; width: 48px; overflow: hidden">
          <pdf :src="'/api/uploads/' + image" sizes="small" align="left" style="margin-right: auto; border-radius: 50%" />
        </div>
      </div>
      <div class="col" style="padding-left: 5px;line-height: 24px" @click="viewInvoice()">
        <div style="font-size:16px;">
          <div> <b>{{ payer ? $t('Pay'):$t('Receiver') }}</b> <b class="cyan-accent">{{ invoice.amount }}€</b> <b>{{ $t('to') }} </b> <b class="cyan-accent"> {{ getNameUser(invoice,payer) }} </b> </div>
          <div> {{ $t('Limit') }} <b>{{ showDate(invoice.dueDate) }}</b> </div>
          <div> {{ $t('Outstanding amount') }} <b>{{ invoice.outstandingAmmount }}€</b></div>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import Constants from "../../constants";
import pdf from 'vue-pdf';
import ApiRepository from "@/repositories/ApiRepository";

export default {
    name: "ItemListInvoice",
    components: {pdf},
    props: {
        invoice: {type: Object, default: null},
        image: { type: String, default: null },
        chat: { type: String, default: null },
        inv: {type: Object, default: null},
        payer: {type: Boolean, default: false},
    },
    data () {
        return {
            status: "",
        };
    },
    async created () {
        console.log(this.image);
        if (this.image === null) {
            await ApiRepository.getInvoiceImage(this.invoice._id).then(res => {
                if (res.data.image)
                    this.image =  res.data.image.originalName;
            });
        }
        this.status = this.factoringStatus(this.invoice.relatedFactorings);
    },
    methods: {
        statusCreated (factoring) {
            if (factoring) {
                return factoring.status === Constants.FACTORING.STATUS_CREATED;
            }
            return false;
        },
        statusRejected (factoring) {
            if (factoring) {
                return factoring.status === Constants.FACTORING.STATUS_REJECTED;
            }
            return false;
        },
        statusCanceled (factoring) {
            if (factoring) {
                return factoring.status === Constants.FACTORING.STATUS_DISCARDED;
            }
            return false;
        },
        statusAccepted (factoring) {
            if (factoring) {
                return factoring.status === Constants.FACTORING.STATUS_ACCEPTED;
            }
            return false;
        },
        statusPayed (factoring) {
            if (factoring) {
                return factoring.status === Constants.FACTORING.STATUS_PAYED;
            }
            return false;
        },
        iAmTheMiddle (factoring) {
            return factoring && factoring.middle._id === this.$user._id;
        },
        iAmThePayer (factoring) {
            return factoring && factoring.payer._id === this.$user._id;
        },
        iAmTheReceiver (factoring) {
            return factoring && factoring.receiver._id === this.$user._id;
        },
        factoringStatus (factorings) {
            let icon = "fas fa-plus";
            if (factorings.length > 0) {
                const factoring = factorings[factorings.length - 1];
                if (this.iAmThePayer(factoring)) {
                    icon = this.statusFactoringPayer(factoring);
                } else if (this.iAmTheMiddle(factoring)) {
                    icon = this.statusFactoringMiddle(factoring);
                } else if (this.iAmTheReceiver(factoring)) {
                    icon = this.statusFactoringReceiver(factoring);
                }
            }
            return icon + " fa-2x";

        },
        statusFactoringPayer (factoring) {
            if (factoring.status === Constants.FACTORING.STATUS_REJECTED) {
                return "fas fa-times";
            } else if ( factoring.acceptedBy === Constants.ACCEPTED_FACTORING.RECEIVER || factoring.acceptedBy === Constants.ACCEPTED_FACTORING.CREATED) {
                //pendent d'acceptar factoring --> alerta
                return "fas fa-exclamation-circle iconRed";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.PAYER) {
                //pendent que C accepti factoring
                return "far fa-clock";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.ALL && factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_UNPAYED) {
                /// factoring acceptat pero sense pagar
                return "fas fa-exclamation-circle iconRed";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.ALL && factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_PAYED) {
                /// Pendent acceptar C
                return "far fa-clock";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.ALL && factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_ACCEPTED ) {
                return "fas fa-check iconGreen";
            } else {
                //iniciar factoring
                return "fas fa-plus";
            }
        },
        statusFactoringMiddle (factoring) {
            if (factoring.status === Constants.FACTORING.STATUS_REJECTED) {
                return "fas fa-times";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.ALL && factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_ACCEPTED ) {
                return "fas fa-check iconGreen";
            }
            return "far fa-clock";
        },
        statusFactoringReceiver (factoring) {
            if (factoring.status === Constants.FACTORING.STATUS_REJECTED) {
                return "fas fa-times";
            } else if ( factoring.acceptedBy === Constants.ACCEPTED_FACTORING.PAYER || factoring.acceptedBy === Constants.ACCEPTED_FACTORING.CREATED) {
                //pendent d'acceptar factoring --> alerta
                return "fas fa-exclamation-circle iconRed";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.RECEIVER) {
                //pendent que A accepti factoring
                return "far fa-clock";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.ALL && factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_UNPAYED) {
                /// factoring acceptat pero sense pagar
                return "far fa-clock";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.ALL && factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_PAYED) {
                /// Pendent acceptar pagament A
                return "fas fa-exclamation-circle iconRed";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.ALL && factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_ACCEPTED && this.invoice.outstandingAmmount === 0 ) {
                return "fas fa-check iconGreen";
            } else if (factoring.acceptedBy === Constants.ACCEPTED_FACTORING.ALL && factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_ACCEPTED && this.invoice.outstandingAmmount > 0 ) {
                return "fas fa-plus";
            } else {
                //iniciar factoring
                return "fas fa-plus";
            }
        },
        showDate (date) {
            if (date) {
                const d = new Date(date);
                return ((d.getDate()) + "-" + (d.getMonth() + 1) + "-" + d.getFullYear());
            } else {
                return "--/--/----";
            }
        },
        getNameUser (invoice, payer) {
            const user = payer ? invoice.receiver : invoice.payer;
            let name = "unknown";
            if (user && user.name) {
                name = user.name;
                if (user.surname) {
                    if (name.length > 0) name += " ";
                    name += user.surname;
                }
            } else if (user && user.cif) {
                name = user.cif;
            } else if (user && user.email) {
                name = user.email;
            }
            return name;
        },
        viewInvoice () {
            this.$router.push({ name: 'viewInvoice',  query: {invoiceId: this.invoice._id, chatId: this.chat}, replace: true });
        },
        viewFactoring () {
            this.$router.push({ name: 'viewInvoice', params: {byppay: this.status === "fas fa-plus fa-2x" }, query: {invoiceId: this.invoice._id}, replace: true });
        }

    },


};
</script>

<style scoped>
  .pare div { padding: 0; }
  .iconGreen{
    color:var(--v-success-base) !important;
  }
  .iconRed{
    color:var(--v-error-base) !important;
  }
</style>
